import {TimelineCommentators} from 'utils/types';
import useMatchInfo from './useMatchInfo';
import useMatchLiveData from './useMatchLiveData';

/**
 * Provides list of match commentators.
 * @param matchId MongoDB match Id (provided by URL)
 */

const useTimelineCommentary = (matchId: string): TimelineCommentators | undefined => {
  // BIQ: assert valid SR ID - do we need matchid at all?
  // FIXME: move commentary to 1m polling
  const [matchLiveDataState] = useMatchLiveData();

  // const commentary = useMemo(
  //   () => ({
  //     reporters: ['Δημήτρης Σαμόλης'],
  //     commentators: ['Παντελής Διαμαντόπουλος', 'Θέμης Καίσαρης', 'Παντελής Βλαχόπουλος'],
  //   }),
  //   [matchId]
  // );

  return matchLiveDataState.data?.commentary;
};

export default useTimelineCommentary;
